<template>
  <a-modal
    :title="title"
    :visible="open"
    :confirm-loading="submitLoading"
    @ok="submitForm"
    @cancel="cancel"
  >
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item has-feedback :label="$t('accountSettings.oldPassword')" prop="oldPassword">
        <a-input-password v-model="form.oldPassword" :placeholder="$t('accountSettings.inputOldPassword')" :maxLength="20" />
      </a-form-model-item>
      <a-form-model-item has-feedback :label="$t('accountSettings.newPassword')" prop="newPassword">
        <a-input-password v-model="form.newPassword" :placeholder="$t('accountSettings.inputNewPassword')" :maxLength="20" />
      </a-form-model-item>
      <a-form-model-item has-feedback :label="$t('accountSettings.confirmPassword')" prop="confirmPassword">
        <a-input-password v-model="form.confirmPassword" :placeholder="$t('accountSettings.confirmPasswordPlaceholder')" :maxLength="20" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
import { updateUserPwd } from '@/api/system/user'

export default {
  props: {
  },
  data () {
    const validateNewPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('accountSettings.newPasswordRequired')))
      } else if (!/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){5,20}$/.test(value)) {
        callback(new Error(this.$t('accountSettings.newPasswordFormatError')))
      } else {
        if (this.form.confirmPassword !== '') {
          this.$refs.form.validateField('confirmPassword')
        }
        callback()
      }
    }
    const validateConfirmPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('accountSettings.confirmPasswordRequired')))
      } else if (value !== this.form.newPassword) {
        callback(new Error(this.$t('accountSettings.passwordMismatch')))
      } else {
        callback()
      }
    }
    return {
      submitLoading: false,
      open: false,
      childrenDrawer: false,
      formLayout: 'horizontal',
      form: {
        oldPassword: undefined,
        newPassword: undefined,
        confirmPassword: undefined
      },
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 14 }
      }
    }
  },
  computed: {
    title() {
      return this.$t('accountSettings.resetPassword')
    },
    rules() {
      const validateNewPass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('accountSettings.newPasswordRequired')))
        } else if (!/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){5,20}$/.test(value)) {
          callback(new Error(this.$t('accountSettings.newPasswordFormatError')))
        } else {
          if (this.form.confirmPassword !== '') {
            this.$refs.form.validateField('confirmPassword')
          }
          callback()
        }
      }
      const validateConfirmPass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('accountSettings.confirmPasswordRequired')))
        } else if (value !== this.form.newPassword) {
          callback(new Error(this.$t('accountSettings.passwordMismatch')))
        } else {
          callback()
        }
      }
      return {
        oldPassword: [
          { required: true, message: this.$t('accountSettings.passwordRequired') }
        ],
        newPassword: [
          { required: true, validator: validateNewPass, trigger: 'change' }
        ],
        confirmPassword: [
          { required: true, validator: validateConfirmPass, trigger: 'change' }
        ]
      }
    }
  },
  mounted () {
    this.reset()
  },
  methods: {
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.form = {
        oldPassword: undefined,
        newPassword: undefined,
        confirmPassword: undefined
      }
    },
    handleUpdatePwd () {
      this.open = true
    },
    /** 重置密码按钮操作 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
        updateUserPwd(this.form.oldPassword, this.form.newPassword).then(response => {
          this.$message.success(
            this.$t('accountSettings.updateSuccess'),
            3
          )
          this.open = false
        }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
